import type {InputHTMLAttributes} from "react";
import {cn} from "@/lib/utils";
export function Input({className,...props}:InputHTMLAttributes<HTMLInputElement>) { return <input className={cn("avm-native-input w-full",className)} {...props}/>; }
